import { ConfirmSteps } from '~/components/ConfirmSteps';
import { useAcceptOrder } from '../hooks/useAcceptOrder';
import { useStore } from '~/shared/hooks/useStore';
import classes from './VerificationCode.module.scss';
import { useCode } from '../hooks/useCode';
import { useTranslation } from 'react-i18next';
import { useConfirmForm } from '../hooks/useConfirmForm';

const VerificationCode = () => {
    const { CLinks } = useStore();
    const [confirmOrder, loadingAccept] = useAcceptOrder(CLinks.links.confirm_order);
    const { setCode, maskedCode, code, visibleIndex } = useCode();
    const { onSubmitForm, register } = useConfirmForm({ submitHandler: confirmOrder, setCode });
    const { t } = useTranslation('components');


    return (
        <>
            <h1 className={classes.title}>{t('components:pages.confirmPage.mainTitle')}</h1>
            <ConfirmSteps activeStep={2} />
            <form className={classes.form} onSubmit={onSubmitForm}>
                <div className={classes.code}>
                    {maskedCode.map((char, index) => (
                        <div key={index} className={`${classes.code_cell}`}>{index === visibleIndex ? char : (char ? '⚹' : '')}</div>
                    ))}
                    <input
                        type='number'
                        inputMode='numeric'
                        {...register('code', { required: true, maxLength: 4 })}
                        onChange={(e) => setCode(e.target.value)}
                        value={code}
                    />
                </div>
                <button
                    type='submit'
                    className={`button button-fill ${classes.button}`}
                    style={{ fontSize: t('confirm.buttonAccept.label').length >= 20 ? 12 : 16 }}
                >
                    {loadingAccept ? t('confirm.buttonAccept.loading') : t('confirm.buttonAccept.label')}
                </button>
            </form>
        </>
    );
};

export default VerificationCode;
